import Ad from "@components/Advertisement/Ad";
import AdSettings from "@components/Advertisement/AdSettings";
import Container from "@components/Container/Container";
import GAData from "@components/GAData/GAData";
import Column from "@components/Grid/Column";
import Row from "@components/Grid/Row";
import MetaTags from "@components/MetaTags/MetaTags";
import EventsAwardsFooter from "@events-awards/components/EventsAwardsFooter";
import EventsAwardsNavigationBar from "@events-awards/EventsAwardsNavigationBarComponents/EventAwardsNavigationBar";
import EventsAwardsNews from "@events-awards/EventsAwardsNews";
import { AWARDS_EVENTS_PAGE_ROW_DATA } from "@events-awards/utils/constants";
import { EventsAwardsNewsContextData } from "@events-awards/utils/types";
import { useDetectAdBlock } from "adblock-detect-react";

import { getEventAwardsNewsTitle } from "./utils/helpers";
import EventsAwardsHeader from "./EventAwardsHeader";

/**
 * Component to render SIA news page content
 */
const EventsAwardsNewsPageContent = ({
  title,
  articles,
  awardType,
}: EventsAwardsNewsContextData): React.ReactElement => {
  const adBlockDetected = useDetectAdBlock();

  const awardData = AWARDS_EVENTS_PAGE_ROW_DATA.find(
    (data) => data.awardType === awardType
  );
  const awardPath = awardData?.blockTitleProps?.link || "";

  return (
    <div
      className="min-h-screen w-full bg-gray-50"
      data-testid="events-awards-news-page-component"
    >
      <AdSettings
        adNames={["lb1", "prestitial", "catfish"]}
        path={`${awardPath}/news`}
        adTargets={[{ key: "page", value: "listing" }]}
      />

      <GAData
        title={`${awardData?.blockTitleProps?.text} News`}
        chapter1={awardData?.blockTitleProps?.text}
        level2="events news"
        adblocker={adBlockDetected ? 1 : 0}
      />

      <MetaTags
        title={getEventAwardsNewsTitle(title, awardType)}
        description={`The Business Times ${awardData?.blockTitleProps?.text} - ${awardData?.description}`}
        ogType="website"
        slug={awardPath}
      />

      <EventsAwardsHeader />

      <Container>
        <Row>
          <Column rootClassName="w-full">
            <EventsAwardsNavigationBar awardType={awardType} />

            <EventsAwardsNews
              articles={articles}
              title="test"
              awardType={awardType}
            />
          </Column>
        </Row>
      </Container>

      <EventsAwardsFooter awardType={awardType} />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default EventsAwardsNewsPageContent;
